<template>
    <div class="warpper">
        <div class="headers">
            <div class="left">
                <div class="itemselect">
                    <p>品类:</p>
                    <mySelect
                        placeholders="请选择品类"
                        v-model="query.type_no"
                        :options="pullData.type"
                        class="select"
                        values="kind_no"
                        labels="kind_name"
                        keys="kind_no"
                    ></mySelect>
                </div>
                <div class="itemselect">
                    <p>品目:</p>
                    <mySelect
                        placeholders="请选择品目"
                        v-model="query.kind_no"
                        :options="pullData.kind"
                        class="select"
                        values="kind_no"
                        labels="kind_name"
                        keys="kind_no"
                    ></mySelect>
                </div>
                <div class="itemselect">
                    <p>金成色:</p>
                    <mySelect
                        placeholders="请选择金成色"
                        v-model="query.gold_no"
                        :options="pullData.gold"
                        class="select"
                        values="kind_no"
                        labels="kind_name"
                        keys="kind_no"
                    ></mySelect>
                </div>
                <div class="itemselect">
                    <el-input placeholder="编号/名称/备注" v-model="query.seek"></el-input>
                    <el-button type="primary" style="margin-left: 10px" @click="searchIt">{{ $t('common.search') }}</el-button>
                </div>
            </div>
            <div class="right">
                <el-button type="success" plain @click="labelClicks()" v-if="perData.allow_print == 1">标签打印</el-button>
                <el-button type="primary" @click="add" v-if="perData.allow_add == 1">{{ $t('common.add') }}</el-button>
                <el-button type="" plain @click="showOut">{{ $t('common.export') }}</el-button>
                <!--                <el-button type="primary" @click="downloadTemplate">下载导入模板</el-button>-->
                <el-button type="primary" style="margin-right: 10px" @click="showImpotDialog = true">导入</el-button>
                <el-upload
                    v-show="false"
                    style="border: none; color: #000"
                    class="daoru"
                    action=""
                    :on-change="inExcels"
                    :show-file-list="false"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                    :auto-upload="false"
                >
                </el-upload>
                <el-dropdown trigger="click" @command="handleCommand">
                    <el-button plain> 批量操作<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <!-- <el-dropdown-item command="1">{{ $t('common.audit') }}</el-dropdown-item>
                        <el-dropdown-item command="2">反审</el-dropdown-item> -->
                        <el-dropdown-item command="3">启用</el-dropdown-item>
                        <el-dropdown-item command="4">停用</el-dropdown-item>
                        <el-dropdown-item command="5">结价产品</el-dropdown-item>
                        <el-dropdown-item command="6">结料产品</el-dropdown-item>
                        <el-dropdown-item command="7">绑定柜台</el-dropdown-item>
                        <el-dropdown-item command="9">上传图片</el-dropdown-item>
                        <el-dropdown-item command="10">带图片导出</el-dropdown-item>
                        <el-dropdown-item command="11" v-if="perData.allow_dele == 1">{{ $t('common.delete') }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>

        <div class="table">
            <el-table
                :data="productData"
                border
                stripe
                class="table"
                ref="table"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="40"> </el-table-column>
                <el-table-column type="index" width="50"> </el-table-column>
                <el-table-column label="产品编号" width="100" prop="style_no"></el-table-column>
                <el-table-column label="产品名称" width="200" prop="style_name"></el-table-column>
                <el-table-column label="图片" width="200">
                    <template #default="{ row }">
                        <el-image
                            v-for="(item, index) in row.imgs"
                            :key="index"
                            :src="item"
                            :preview-src-list="row.imgs"
                            style="width: 30px; height: 30px; margin-right: 10px"
                        ></el-image>
                    </template>
                </el-table-column>
                <el-table-column label="品类" width="100" prop="type_name"></el-table-column>
                <el-table-column label="品目" width="100" prop="kind_name"></el-table-column>
                <el-table-column label="金成色" width="100" prop="gold_name"></el-table-column>
                <el-table-column label="结价产品" width="150" prop="balprc_style_name"></el-table-column>
                <el-table-column label="结料产品" width="150" prop="tran_style_name"></el-table-column>
                <el-table-column label="状态" width="120">
                    <template #default="{ row }">
                        <el-tag :type="row.status == 1 ? 'success' : 'danger'">{{ row.status == 1 ? '启用' : '停用' }}</el-tag>
                        <el-switch
                            v-model="row.status"
                            style="margin-left: 5px"
                            active-value="1"
                            inactive-value="0"
                            :disabled="perData.allow_edit == 0"
                            @change="styleStatus(row)"
                        >
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="200">
                    <template #default="{ row }">
                        <el-button type="primary" plain @click="goDetail(row)">查看详情</el-button>
                        <el-button type="success" plain @click="labelClick(row)" v-if="perData.allow_print == 1">标签打印</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination" style="text-align: right">
                <el-pagination
                    background
                    layout="total,sizes, prev, pager, next"
                    :current-page="query.page"
                    :page-size="query.page_size"
                    :page-sizes="[10, 20, 30, 40]"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
        </div>
        <!-- //批量操作 -->
        <el-dialog title="批量操作" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
            <div v-if="command == 5">
                <div class="itemselect">
                    <p>结价产品:</p>
                    <mySelect
                        placeholders="请选择结价产品"
                        v-model="styleid"
                        :options="pullData.stylesec"
                        class="select"
                        values="kind_no"
                        labels="kind_name"
                        keys="kind_no"
                    ></mySelect>
                </div>
            </div>
            <div v-if="command == 6">
                <div class="itemselect">
                    <p>结料产品:</p>
                    <mySelect
                        placeholders="请选择结料产品"
                        v-model="styleid"
                        :options="pullData.stylesec"
                        class="select"
                        values="kind_no"
                        labels="kind_name"
                        keys="kind_no"
                    ></mySelect>
                </div>
            </div>
            <div v-if="command == 7">
                <div class="itemselect">
                    <p>绑定柜台:</p>
                    <mySelect
                        placeholders="请选择柜台"
                        v-model="styleid"
                        :options="pullData.counter"
                        class="select"
                        values="kind_no"
                        labels="kind_name"
                        keys="kind_no"
                    ></mySelect>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="comirm">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 导入明细弹窗 -->
        <el-dialog title="导入产品资料" :visible.sync="showImpotDialog" width="45%" :before-close="handleDialogClose">
            <div class="importDialogCenter">
                <div class="centerItem leftItem" @click="outTem">
                    <i class="el-icon-download avatar-uploader-icon"></i>
                    <p class="itemText">点击下载模板</p>
                </div>
                <div class="centerItem">
                    <el-upload
                        class="upload-demo"
                        :on-error="uploadError"
                        :on-success="uploadSuccessdr"
                        :show-file-list="false"
                        style="width: 100%"
                        :headers="headers"
                        drag
                        :action="this.$baseURL + 'import_Stylesec'"
                        multiple
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" style="text-align: center" slot="tip">支持拓展名：.xlsx</div>
                    </el-upload>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showImpotDialog = false">取 消</el-button>
                <el-button type="primary" @click="showImpotDialog = false">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="提示" :visible.sync="updialogVisible" width="400px" :before-close="clearFile">
            <el-upload
                action="#"
                class="upload-demo"
                ref="upload"
                :on-remove="handleRemove"
                multiple
                :on-change="
                    (file, fileList) => {
                        handleChange(file, fileList);
                    }
                "
                :on-success="handleAvatarSuccess"
                :file-list="fileList"
                :http-request="submitUpload"
                :auto-upload="false"
            >
                <!-- :on-change="handleChange" -->
                <div
                    class="el-upload-dragger"
                    v-loading="loading"
                    element-loading-text="正在上传"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                >
                    <i class="el-icon-upload" :style="{ fontSize: '66px', marginTop: '25px' }"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </div>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="fileList.length > 0" type="primary" @click="clearFile" :disabled="loading" icon="el-icon-refresh-left"
                    >清空</el-button
                >
                <el-button
                    v-if="fileList.length > 0"
                    v-loading="loading"
                    type="primary"
                    @click="submitForm"
                    icon="el-icon-upload"
                    element-loading-text="正在上传文件"
                    element-loading-spinner="el-icon-loading"
                    >上传</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    styleIndex,
    stylePull,
    styleCheck,
    styleHandle,
    styleExport,
    styleLeadingIn,
    styleDel,
    apiCurrentPermisson,
    styleprintLabelStylesec
} from '@/request/api';

export default {
    name: 'productMeans',
    data() {
        return {
            loopIndex: 0,
            uploadSuccess: false,
            uploadForm: {
                file: [],
                parameter: null
            },
            loading: false,
            fileList: [],
            fileDate: null,
            updialogVisible: false,
            // 上传图片时的附加数据
            uploadImgData: {}, // 初始化为一个空对象
            productData: [{ seq: 1, status: 1 }],
            query: {
                page: 1,
                page_size: 10,
                type_no: '',
                kind_no: '',
                gold_no: '',
                seek: ''
            },
            pageTotal: 20,
            pullData: {},
            styleid: '',
            dialogVisible: false,
            command: 0,
            dataAll: [],
            showImpotDialog: false,
            headers: {},
            perData: {} //权限
        };
    },
    mounted() {
        this.getData();
        this.getPull();
        this.getPermission();
        //
        // //
        let token = sessionStorage.getItem('userToken');
        this.headers.Authorization = 'Bearer ' + token;
    },
    activated() {
        this.getData();
        this.getPull();
    },
    methods: {
        // 标签打印
        labelClick(row) {
            styleprintLabelStylesec({ id: row.id }).then((res) => {
                if (res.code == 2000) {
                    this.$router.push({
                        path: '/printingfusion',
                        query: {
                            url: res.data.Url
                        }
                    });
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        labelClicks() {
            let idArr = [];
            this.dataAll.forEach((item) => {
                idArr.push(item.id);
            });
            let ids = idArr;
            styleprintLabelStylesec({ ids: ids }).then((res) => {
                if (res.code == 2000) {
                    this.$router.push({
                        path: '/printingfusion',
                        query: {
                            url: res.data.Url
                        }
                    });
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '121'
            }).then((res) => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getData() {
            styleIndex({ ...this.query }).then((res) => {
                this.productData = res.data.data;
                this.pageTotal = res.data.count;
                this.$forceUpdate();
            });
        },
        getPull() {
            stylePull().then((res) => {
                this.pullData = res.data;
            });
        },
        // 导出
        showOut(e) {
            this.$load.show();
            // styleExport({}).then(res => {
            //     if (res.code == 2000) {
            //         this.username = res.data.login_staff;
            //     } else {
            //         this.$message.error(res.msg);
            //     }
            // });
            let idArr = [];
            this.dataAll.forEach((item) => {
                idArr.push(item.id);
            });
            let ids = idArr.join(',');
            this.query.id = ids;
            if (e == '10') {
                this.query.haveimg = '1';
            } else {
                this.query.haveimg = '0';
            }
            this.$axios
                .get(this.$baseURL + 'style_export', {
                    params: {
                        ...this.query
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '产品资料库.xlsx';
                    link.click();
                    this.$load.close();
                });
            // window.location = this.$baseURL + 'style_export';
        },
        // 下载导入模板
        downloadTemplate() {
            this.$axios
                .get(this.$baseURL + 'style_template_export', {
                    params: {
                        token: sessionStorage.getItem('userToken')
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '产品资料导入模板' + '.xlsx';
                    link.click();
                });
        },
        // 导入--调用上传组件
        leadingIn() {
            document.querySelector('.daoru input').click();
        },
        handleDialogClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done();
                })
                .catch((_) => {});
        },
        // 导入拖拽成功的钩子
        uploadSuccessdr(res) {
            if (res.code == 2000) {
                this.$message.success(res.msg);
                this.getData();
                this.showImpotDialog = false;
            } else {
                if (res.data.info instanceof Array) {
                    let str = [];
                    var s = '';
                    str = res.data.info;
                    for (let i = 0; i < str.length; i++) {
                        s += str[i] + '<br/>';
                    }
                    this.$message({
                        type: 'error',
                        showClose: true,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: s
                    });
                } else {
                    this.$message.error(res.data.info);
                }
                // this.$message.error(res.data.info[0]);
            }
        },
        uploadError(r) {
            this.$message.error('上传失败');
        },
        outTem() {
            this.$axios
                .get(`${this.$baseURL}template_export_Stylesec`, {
                    params: {
                        token: this.token,
                        type: '产品资料'
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data]);
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '产品资料导入模板.xls';
                    link.click();
                });
        },
        // 导入上传文件
        inExcels(file) {
            let data = new FormData(); //创建form对象
            data.append('file', file.raw);
            styleLeadingIn(data).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.getData();
                } else {
                    let str = [];
                    var s = '';
                    str = res.data.info;
                    for (let i = 0; i < str.length; i++) {
                        s += str[i].error + '<br/><br/>';
                    }
                    this.$message({
                        type: 'error',
                        showClose: true,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: s
                    });
                }
            });
        },
        // 搜索
        searchIt() {
            this.query.page = 1;
            this.getData();
        },
        // 审核
        styleCheck(row) {
            styleCheck({
                id: row.id,
                check: row.check
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.data);
                } else {
                    this.$message.error(res.data);
                }
            });
        },
        styleStatus(row) {
            let command;

            if (row.status == 1) {
                command = 3;
            } else {
                command = 4;
            }

            styleHandle({
                type: command,
                id: row.id
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.data);
                    this.getData();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 多选删除操作
        handleSelectionChange(row) {
            this.dataAll = row;
            // let data = this.$refs.table.getCheckboxRecords();
        },
        // 批量操作
        handleCommand(command) {
            this.command = command;
            if (command == '10') {
                this.showOut('10');
                return;
            }
            if (command == '9') {
                this.updialogVisible = true;
                return;
            }
            if (this.dataAll.length == 0) {
                this.$message.warning('请选择需要操作的数据');
                return;
            }
            if (command == 5 || command == 6|| command == 7) {
                this.dialogVisible = true;
                return;
            }
            let idArr = [];
            this.dataAll.forEach((item) => {
                idArr.push(item.id);
            });
            let ids = idArr.join(',');
            if (command == 11) {
                this.$confirm('确定要删除该产品资料吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    styleDel({
                        id: ids
                    }).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success(res.data);
                            // this.changeOrder(4);
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                });
                return;
            }
            styleHandle({
                type: command,
                id: ids
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.data);
                    this.getData();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },

        handleAvatarSuccess(resp, file, fileList) {},
        clearFile() {
            this.fileList = [];
            this.uploadSuccess = false;
            this.updialogVisible = false;
        },
        submitUpload(file) {
            if (this.loopIndex === 0) {
                this.loopIndex = this.loopIndex + 1;
                this.fileList.forEach((file, index) => {
                    this.fileDate.append(`images[${index}]`, file.raw);
                });
            }
            console.log(this.fileDate);
        },
        submitForm() {
            // return;
            if (!this.loading) {
                // if (this.fileList[1]) {
                //     [this.fileList[0], this.fileList[1]] = [this.fileList[1], this.fileList[0]];
                // }
                this.fileDate = new FormData();
                this.$refs.upload.uploadFiles = this.fileList;
                this.$refs.upload.submit();
                this.loading = true;
                console.log(this.fileDate, '?d');
                this.$axios({
                    method: 'POST',
                    url: `${this.$baseURL}uploadImgs_Stylesec`,
                    data: this.fileDate
                }).then((res) => {
                    console.log(res);
                    this.loading = false;
                    if (res.data.code === 2000) {
                        this.fileList.forEach((file) => {
                            file.status = 'success';
                        });
                        this.$message.success(res.data.data);
                        this.getData();
                    } else {
                        if (res.data.data.info instanceof Array) {
                            let str = [];
                            var s = '';
                            str = res.data.data.info;
                            for (let i = 0; i < str.length; i++) {
                                s += str[i] + '<br/>';
                            }
                            this.$message({
                                type: 'error',
                                showClose: true,
                                duration: 0,
                                dangerouslyUseHTMLString: true,
                                message: s
                            });
                        } else {
                            this.$message.error(res.data.data.info);
                        }
                    }
                    this.loopIndex = 0;
                    this.fileList = [];
                    this.updialogVisible = false;
                });
            }
        },
        handleChange(file, fileList) {
            this.fileList = fileList;
            this.uploadSuccess = false;
        },
        handleRemove(file, fileList) {
            this.fileList = fileList;
        },
        comirm() {
            let idArr = [];
            this.dataAll.forEach((item) => {
                idArr.push(item.id);
            });
            let ids = idArr.join(',');
            styleHandle({
                type: this.command,
                id: ids,
                sid: this.styleid
            }).then((res) => {
                this.dialogVisible = false;
                if (res.code == 2000) {
                    this.$message.success(res.data);
                    this.getData();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        handleClose() {
            this.dialogVisible = false;
        },
        // 查看详情
        goDetail(row) {
            this.$router.push({
                path: '/productMeansDetail',
                query: { detailid: row.id }
            });
        },
        // 新增
        add() {
            this.$router.push({
                path: '/productMeansDetail',
                query: { isadd: true }
            });
        },
        //分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.query.page = val;
            this.getData();
        },
        pageSizeChange(val) {
            this.query.page_size = val;
            this.getData();
        }
    }
};
</script>

<style scoped lang="scss">
.warpper {
    background-color: #fff;
    padding: 15px;
    box-sizing: border-box;
}
.headers {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .left {
        display: flex;
        .itemselect {
            display: flex;
            align-items: center;
            width: 200px;
            margin-left: 20px;

            p {
                font-size: 14px;
                color: #131414;
                width: 70px;
            }
        }
    }
}
.importDialogCenter {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    .centerItem {
        width: 48%;
        text-align: center;
        /deep/ .el-upload--text {
            width: 100%;
            height: 100%;
        }
        /deep/ .el-upload-dragger {
            width: 100%;
        }
    }
    .leftItem {
        width: 48%;
        height: 180px;
        cursor: pointer;
        box-sizing: border-box;
        position: relative;
        border-radius: 8px;
        border: 1px dashed #97a8be;
        .itemText {
            position: absolute;
            top: 70%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
}
.table {
    width: 100%;
    font-size: 14px;
}
.itemselect {
    display: flex;
    align-items: center;
    p {
        width: 80px;
    }
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    // width: 178px;
    // height: 178px;
    line-height: 178px;
    text-align: center;
}
</style>
<style>
.el-table thead {
    color: #000;
    font-weight: bold;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #ecf5ff;
}
.el-table th {
    background: #ecf5ff !important;
}
</style>
